import { InternalAxiosRequestConfig } from "axios";

export const multipartInterceptor = (config: InternalAxiosRequestConfig) => {
  if (config.headers["Content-Type"] === "multipart/form-data") {
    config.data = makeItMultipartParams(config.data);
  }

  return config;
};

export const makeItMultipartParams = (
  obj: Record<string, any>,
  form?: FormData,
  namespace?: string,
): FormData => {
  const formData = form || new FormData();

  for (const property in obj) {
    if (obj.hasOwnProperty(property)) {
      const key = namespace ? `${namespace}[${property}]` : property;
      const value = obj[property];

      if (value instanceof Date) {
        formData.append(key, value.toISOString());
      } else if (value && typeof value === "object" && value instanceof File) {
        // Adiciona arquivos com propriedades uri, name e type
        formData.append(key, value);
      } else if (
        typeof value === "object" &&
        !(value instanceof File) &&
        !Array.isArray(value)
      ) {
        makeItMultipartParams(value, formData, key);
      } else if (Array.isArray(value)) {
        value.forEach((element, index) => {
          const arrayKey = `${key}[${index}]`;
          if (typeof element === "object" && element.uri && element.type) {
            // Adiciona arquivos com propriedades uri, name e type
            formData.append(arrayKey, element);
          } else if (typeof element === "object") {
            makeItMultipartParams(element, formData, arrayKey);
          } else {
            formData.append(arrayKey, element?.toString());
          }
        });
      } else {
        formData.append(key, value?.toString());
      }
    }
  }

  return formData;
};
